import { makeStyles } from "tss-react/mui";
import { IStatusDisplayConfig } from "@miplatform/types";
import { Typography } from "@mui/material";

export const WorkCardStatus = ({
  status,
  config = {},
  date,
  bottomText,
}: {
  status: string;
  config: Record<string, IStatusDisplayConfig>;
  date?: string;
  bottomText?: string;
}) => {
  const { color, label = "Unknown", backgroundColor } = config[status] || {};
  const { classes, cx, theme } = useStyles({ backgroundColor });

  return (
    <div className={classes.workCardStatusContainer}>
      <Typography className={classes.statusText} color={color}>
        {label}
      </Typography>
      {date && (
        <Typography className={classes.statusText} color={color}>
          {date}
        </Typography>
      )}
      {bottomText && (
        <Typography
          className={cx(classes.statusText, classes.bottomText)}
          color={theme.palette.grey.mediumDark}
        >
          {bottomText}
        </Typography>
      )}
    </div>
  );
};

const useStyles = makeStyles<{ backgroundColor: string }>()(
  (theme, { backgroundColor }) => ({
    workCardStatusContainer: {
      backgroundColor: backgroundColor ?? theme.palette.grey.lightAccent,
      padding: theme.spacing(0.5, 1),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      overflow: "hidden",
    },
    statusText: {
      fontSize: "0.6rem",
      letterSpacing: 0.15,
    },
    bottomText: {
      textWrap: "nowrap",
      textOverflow: "ellipsis",
      maxWidth: "100%",
      overflow: "hidden",
      textAlign: "center",
    },
  })
);
